import React from 'react';
import { cn } from '../../../utils';

const CenterDiv = ({
  className,
  children,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => {
  return (
    <div className={cn('w-full centerDiv', className)} {...props}>
      {children}
    </div>
  );
};

export default CenterDiv;
